import React from 'react'
import Campaigns from './Campaigns'

function BroadcastReportPage({ showSidebar }) {
    return (
        <Campaigns showSidebar={showSidebar} showAsReport={true} />
    )
}

export default BroadcastReportPage